import { render, staticRenderFns } from "./HomeNotificationCard.vue?vue&type=template&id=8bbce702&scoped=true"
import script from "./HomeNotificationCard.vue?vue&type=script&lang=js"
export * from "./HomeNotificationCard.vue?vue&type=script&lang=js"
import style0 from "./HomeNotificationCard.vue?vue&type=style&index=0&id=8bbce702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbce702",
  null
  
)

export default component.exports